import React from 'react'
import { Modal } from '@enamelai/design-system'
import { formatUnsavedChangesDescription } from './charting-unsaved-changes.utils'

type ChartingUnsavedChangesModalProps = {
  show: boolean
  unsavedTabs?: string[]
  onKeepEditing: () => void
  onDiscard: () => void
}

const ChartingUnsavedChangesModal: React.FC<
  ChartingUnsavedChangesModalProps
> = ({ show, unsavedTabs = [], onKeepEditing, onDiscard }) => (
  <Modal
    open={show}
    onClose={onKeepEditing}
    size="xs"
    title="Unsaved changes"
    description={formatUnsavedChangesDescription(unsavedTabs)}
    primaryLabel="Discard"
    secondaryLabel="Keep editing"
    primaryDestructive
    onPrimaryClick={onDiscard}
    onSecondaryClick={onKeepEditing}
  />
)

export default ChartingUnsavedChangesModal
